var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofOfUseLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30.3333,
    height: 30.3333,
    viewBox: "0 0 30.3333 30.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_all"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7186 8.93333V15L18.763 17.0222M24.8297 15C24.8297 20.5842 20.3028 25.1111 14.7186 25.1111C9.13437 25.1111 4.60747 20.5842 4.60747 15C4.60747 9.41579 9.13437 4.88889 14.7186 4.88889C20.3028 4.88889 24.8297 9.41579 24.8297 15Z",
    strokeWidth: 1.76944,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#1F2129"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfUseLg);
export default __webpack_public_path__ + "static/media/proof-of-use-lg.74a5063fe41ce66cac95d225a0008096.svg";
export { ForwardRef as ReactComponent };